var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Aggregate", {
    attrs: {
      title: "Markets",
      ItemConstructor: _vm.CaseModel.MarketProject,
      headers: _vm.CaseModel.MarketProject.HEADERS,
      cardProps: { flat: true, class: [] },
      "toolbar-dense": "",
    },
    on: {
      change: function ($event) {
        return _vm.$emit("change")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var item = ref.item
          var itemIndex = ref.itemIndex
          return [
            _c(
              "v-card",
              { staticClass: "mb-3", attrs: { flat: "" } },
              [
                _c(
                  "v-card-text",
                  { staticClass: "px-0" },
                  [
                    _c("InputGeo", {
                      attrs: {
                        label: "Coordinates",
                        "map-height": "150",
                        nullable: "",
                        "switch-text": "Use Market coordinates",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                      model: {
                        value: item.coordinates,
                        callback: function ($$v) {
                          _vm.$set(item, "coordinates", $$v)
                        },
                        expression: "item.coordinates",
                      },
                    }),
                    _c(
                      "v-expansion-panels",
                      {
                        staticClass: "mx-0 px-0",
                        attrs: { tile: "", flat: "" },
                        model: {
                          value: _vm.panelState,
                          callback: function ($$v) {
                            _vm.panelState = $$v
                          },
                          expression: "panelState",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          { key: 0 },
                          [
                            _c(
                              "v-expansion-panel-header",
                              {
                                class:
                                  "subtitle-1 font-weight-medium " +
                                  _vm.isEnabled(item.energy),
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "shrink mr-4" },
                                      [
                                        _c("v-switch", {
                                          staticClass: "my-0 pt-0",
                                          attrs: { dense: "", height: 25 },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleItem(
                                                $event,
                                                itemIndex,
                                                "energy"
                                              )
                                            },
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                          model: {
                                            value: item.energyEnabled,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "energyEnabled",
                                                $$v
                                              )
                                            },
                                            expression: "item.energyEnabled",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-col", [_vm._v(" Energy ")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              [
                                _c("SystemProjectSubMarket", {
                                  attrs: {
                                    num_years: _vm.num_years,
                                    year_start: _vm.year_start,
                                    errors: _vm.errors,
                                    "project-coordinates":
                                      _vm.projectCoordinates,
                                    toggleable: "",
                                    open: _vm.panelState === 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.energy,
                                    callback: function ($$v) {
                                      _vm.$set(item, "energy", $$v)
                                    },
                                    expression: "item.energy",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-expansion-panel",
                          { key: "ppa" },
                          [
                            _c(
                              "v-expansion-panel-header",
                              {
                                class:
                                  "subtitle-1 font-weight-medium " +
                                  _vm.isEnabled(item.ppa.active),
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "shrink mr-4" },
                                      [
                                        _c("v-switch", {
                                          staticClass: "my-0 pt-0",
                                          attrs: { dense: "", height: 25 },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                          model: {
                                            value: item.ppa.active,
                                            callback: function ($$v) {
                                              _vm.$set(item.ppa, "active", $$v)
                                            },
                                            expression: "item.ppa.active",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-col", [
                                      _vm._v(" Power Purchase Agreement "),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              [
                                item.ppa.active
                                  ? _c("InputYearlyProfile", {
                                      attrs: {
                                        "object-value": "",
                                        fill: "",
                                        "toggle-items-type": "",
                                        label: "imports PPA price",
                                        hint: "calculate the earnings from PPAs",
                                        num_years: _vm.num_years,
                                        "profile-type": "PPA_ENERGY_PRICE",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.ppa.imports,
                                        callback: function ($$v) {
                                          _vm.$set(item.ppa, "imports", $$v)
                                        },
                                        expression: "item.ppa.imports",
                                      },
                                    })
                                  : _vm._e(),
                                item.ppa.active
                                  ? _c("InputYearlyProfile", {
                                      attrs: {
                                        "object-value": "",
                                        fill: "",
                                        "toggle-items-type": "",
                                        label: "exports PPA price",
                                        hint: "calculate the earnings from PPAs",
                                        num_years: _vm.num_years,
                                        "profile-type": "PPA_ENERGY_PRICE",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.ppa.exports,
                                        callback: function ($$v) {
                                          _vm.$set(item.ppa, "exports", $$v)
                                        },
                                        expression: "item.ppa.exports",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-expansion-panel",
                          { key: 2 },
                          [
                            _c(
                              "v-expansion-panel-header",
                              {
                                class:
                                  "subtitle-1 font-weight-medium " +
                                  _vm.isEnabled(item.tariffs),
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "shrink mr-4" },
                                      [
                                        _c("v-switch", {
                                          staticClass: "my-0 pt-0",
                                          attrs: { dense: "", height: 25 },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleItem(
                                                $event,
                                                itemIndex,
                                                "tariffs"
                                              )
                                            },
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                          model: {
                                            value: item.tariffsEnabled,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "tariffsEnabled",
                                                $$v
                                              )
                                            },
                                            expression: "item.tariffsEnabled",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-col", [_vm._v(" Tariffs ")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              [
                                _c("SystemProjectSubMarket", {
                                  attrs: {
                                    num_years: _vm.num_years,
                                    year_start: _vm.year_start,
                                    errors: _vm.errors,
                                    "project-coordinates":
                                      _vm.projectCoordinates,
                                    toggleable: "",
                                    open: _vm.panelState === 2,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.tariffs,
                                    callback: function ($$v) {
                                      _vm.$set(item, "tariffs", $$v)
                                    },
                                    expression: "item.tariffs",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-expansion-panel",
                          { key: 3 },
                          [
                            _c(
                              "v-expansion-panel-header",
                              {
                                class:
                                  "subtitle-1 font-weight-medium " +
                                  _vm.isEnabled(item.fuels),
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      { staticClass: "shrink mr-4" },
                                      [
                                        _c("v-switch", {
                                          staticClass: "my-0 pt-0",
                                          attrs: { dense: "", height: 25 },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleItem(
                                                $event,
                                                itemIndex,
                                                "fuels"
                                              )
                                            },
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                          model: {
                                            value: item.fuelsEnabled,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "fuelsEnabled",
                                                $$v
                                              )
                                            },
                                            expression: "item.fuelsEnabled",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-col", [_vm._v(" Fuels ")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              [
                                _c("SystemProjectSubMarket", {
                                  attrs: {
                                    num_years: _vm.num_years,
                                    year_start: _vm.year_start,
                                    errors: _vm.errors,
                                    toggleable: "",
                                    open: _vm.panelState === 3,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.fuels,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fuels", $$v)
                                    },
                                    expression: "item.fuels",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-expansion-panel",
                          { key: 1 },
                          [
                            _c(
                              "v-expansion-panel-header",
                              {
                                class:
                                  "subtitle-1 font-weight-medium " +
                                  _vm.isEnabled(item.reserves),
                              },
                              [_vm._v(" Reserves ")]
                            ),
                            _c(
                              "v-expansion-panel-content",
                              [
                                _c("Aggregate", {
                                  attrs: {
                                    title: "Reserves",
                                    ItemConstructor: _vm.CaseModel.SubMarket,
                                    headers: [
                                      {
                                        text: "Reserve linked",
                                        value: "project_reserve_id",
                                      },
                                    ],
                                    disabled: _vm.addReservesDisabled(item),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item.project_reserve_id",
                                        fn: function (ref) {
                                          var reserve = ref.item
                                          return [
                                            _c("v-select", {
                                              attrs: {
                                                "item-text": "name",
                                                "item-value": "id",
                                                items: _vm.availableReserves(
                                                  item,
                                                  reserve
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  reserve.project_reserve_id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    reserve,
                                                    "project_reserve_id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "reserve.project_reserve_id",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var reserve = ref.item
                                          var errors = ref.errors
                                          return [
                                            _c("SystemProjectSubMarket", {
                                              key: item.id,
                                              attrs: {
                                                num_years: _vm.num_years,
                                                year_start: _vm.year_start,
                                                errors: errors,
                                                "submarket-type": "reserve",
                                                reserves: _vm.reserves,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value:
                                                  item.reserves[reserve.id - 1],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item.reserves,
                                                    reserve.id - 1,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.reserves[reserve.id - 1]",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: item.reserves,
                                    callback: function ($$v) {
                                      _vm.$set(item, "reserves", $$v)
                                    },
                                    expression: "item.reserves",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.computedValue,
      callback: function ($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }